import FrameSettings from './FrameSettings'

export * from './FrameSettings'

export default FrameSettings
